'use strict';

//------------------------------------------------------------------------------------------------
// common code to wire up all submit buttons
//
(function () {
    // find the form, first check if we're in a form, then check for an explicit target,
    // or use the first form on the page
    var getFormFromSubmitButton = function getFormFromSubmitButton(btn) {
        var form = btn.closest('FORM');
        if (form.length === 0 && btn.data('target')) form = $(btn.data('target'));
        if (form.length === 0) form = $('FORM').not('.awsupload FORM').first();
        return form;
    };

    $(function () {
        // function to submit
        var submitOnClick = function submitOnClick(e) {
            e.preventDefault();
            var btn = $(this);
            if (btn.is(':disabled') || btn.hasClass('disabled')) return;

            var form = getFormFromSubmitButton(btn);

            if (form.length === 1) {
                form.submit();
            }
        };
        $('.ws-submit').not('.manual').bind('click.app', submitOnClick);
        // bind to custom submit event
        $('.ws-submit').bind('submit', submitOnClick);
        var wsForm = getFormFromSubmitButton($('.ws-submit'));
        var wsButtons = $(wsForm).find('.ws-submit');
        if (wsForm.length === 1 && !wsForm.hasClass('resubmittable')) {
            wsForm.submit(function () {
                wsForm.submit(function (e) {
                    e.preventDefault();
                    return false;
                });
                wsButtons.attr('disabled', true);
                wsButtons.addClass('disabled');
            });
        }
    });
})();